/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EventValidator
 */
export interface EventValidator {
    /**
     * The ID of the event type this mapping is associated with
     * @type {string}
     * @memberof EventValidator
     */
    eventTypeId: string;
    /**
     * 
     * @type {object}
     * @memberof EventValidator
     */
    jsonValidator?: object;
}

export function EventValidatorFromJSON(json: any): EventValidator {
    return EventValidatorFromJSONTyped(json, false);
}

export function EventValidatorFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventValidator {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'eventTypeId': json['eventTypeId'],
        'jsonValidator': !exists(json, 'jsonValidator') ? undefined : json['jsonValidator'],
    };
}

export function EventValidatorToJSON(value?: EventValidator | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'eventTypeId': value.eventTypeId,
        'jsonValidator': value.jsonValidator,
    };
}


